import React from "react";
import "../StatusSaverPrivacyPolicy.css";
import { useNavigate } from "react-router-dom";
import SEO from "./SEO";

const StatusSaverDataDeletion = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/"); // navigate to homepage
  };

  return (
    <div className="privacy-policy-page">
      <SEO
        title="Data Deletion Instructions - Status Downloader | BlueOrbit Technologies"
        description="Instructions on how users can request data deletion from Status Downloader app. No personal data is collected."
        keywords="data deletion, privacy, Status Downloader, BlueOrbit Technologies"
      />

      <header className="privacy-header">
        <div className="container">
          <nav className="nav">
            <div className="logo" onClick={goHome} style={{ cursor: "pointer" }}>
              <i className="fas fa-orbit"></i>
              <span>BlueOrbit Technologies</span>
            </div>
          </nav>
        </div>
      </header>

      <section className="privacy-hero">
        <div className="container">
          <h1>Data Deletion Instructions</h1>
        </div>
      </section>

      <section className="privacy-content">
        <div className="container">
          <div className="policy-content">
            <div className="policy-section">
              <p>
                This app does not collect or store any personal data from users.
              </p>
              <p>
                If you believe any personal data of yours is stored, please contact us at:
              </p>
              <p>
                <strong>Email:</strong> blueorbittechnologies@gmail.com
              </p>
              <p>
                We will respond and delete any user data upon request as soon as possible.
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer className="privacy-footer">
        <div className="container">
          <div className="footer-bottom">
            <p>&copy; 2025 BlueOrbit Technologies. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default StatusSaverDataDeletion;
